import * as Vue from "vue";
import {Component} from "vue-property-decorator";
import "./adminHome.styl";
const template = require("./adminHome.vue");

@Component({
  template: template
})
export class AdminHomeComponent extends Vue {

}

Vue.component("cmHome", AdminHomeComponent);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/views/adminHome/adminHome.ts